import type { ReportComponentProps } from "@qendo/profile/reports";
import { useMemo } from "react";
import { Report } from "~/components/layout/reports/Report";
import { formatWeekDay } from "~/util/dates";

export const WeeklyReport = ({ report, data, ...reportProps }: ReportComponentProps) => {
    const labels = useMemo(() => data.points.map(({ date }) => formatWeekDay(date, "initial")), [data.points]);

    return <Report {...reportProps} labels={labels} report={report} data={data} initialSpacing={3} endSpacing={3} />;
};
